import _ from 'lodash';

interface ParamsProps {
    state?: string;
    current?: string;
    change?: string;
    invitationUserCode?: string | number;
    campaignId?: string;
    isActivated?: boolean;
    redirect?: string;
    from?: string;
    fromService?: string;
    fromPage?: string;
    product?: string;
}

export function getRedirectParams(data: any) {
    const {
        state,
        current,
        change,
        invitationUserCode,
        campaignId,
        isActivated,
        redirect,
        from,
        fromService,
        fromPage,
        product,
        authScene,
    } = data || {};

    let params: ParamsProps = {
        state,
        authScene,
        redirect: redirect ? encodeURIComponent(redirect) : redirect,
    };

    if (current && change) {
        params = {
            ...params,
            current,
            change,
        };
    }
    else {
        params = {
            ...params,
            from,
            fromPage,
            product,
            invitationUserCode,
            campaignId,
            isActivated,
            fromService,
        };
    }
    const query = _.pickBy(params, val => val === 0 || !!val);
    return query;
}

export function getResultRedirectParams(query: any) {
    const {authScene, redirect, from, product} = query || {};
    const params: any = {
        from,
        product,
        authScene,
        redirect: redirect ? encodeURIComponent(redirect) : redirect,
    };
    const result = _.pickBy(params, val => val === 0 || !!val);
    return result || {};
}
